const STORAGE_KEY = 'autoReconnectSessionUuid';
export function setAutoReconnectSessionUuid(sessionUuid) {
    window.sessionStorage.setItem(STORAGE_KEY, sessionUuid);
}
export function removeAutoReconnectSessionUuid() {
    window.sessionStorage.removeItem(STORAGE_KEY);
}
export function getAutoReconnectSessionUuid() {
    const autoReconnectSessionUuid = window.sessionStorage.getItem(STORAGE_KEY);
    return autoReconnectSessionUuid || undefined;
}
